export default "__VITE_ASSET__7c6122ed__"